module.exports = __webpack_public_path__ + "static/media/business_map.4f0545da.jpg";